import axios from 'axios'
import apiClient from '../client'

export const SENTRYPRIME_URL = import.meta.env.VITE_SENTRYPRIME_URL

export const shopifyService = {
  // Get Shopify store pages through backend API (to avoid CORS)
  getStorePages: async (shop) => {
    const response = await apiClient.get(`/shopify/store-pages`, {
      params: { shop }
    })
    return response.data
  },

  // Check whether the AI accessibility fixer app embed is enabled on the store's theme
  getExtensionStatus: async (shop) => {
    const response = await axios.get(
      `${SENTRYPRIME_URL}/api/accessibility/extension-status`,
      { params: { shop } }
    )
    return response.data
  },
}
